import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-city-efficiency',
    templateUrl: './city-efficiency.component.html',
    styleUrls: ['./city-efficiency.component.scss']
})
export class CityEfficiencyComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
